export default {
  'courier-platforms.courier_api_code': 'Courier API Name',
  'courier-platforms.code': 'Code',
  'courier-platforms.en_name': 'Name (EN)',
  'courier-platforms.cn_name': 'Name (CN)',
  'courier-platforms.status': 'Status',
  'courier-platforms.update': 'Update',
};
